export default {
    name: 'SMenu',
    props: {
        menu: {
            type: Array,
            required: true
        },
        collapse: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            openKeys: [],
            selectedKeys: [],
            cachedOpenKeys: []
        }
    },
    computed: {
        rootSubmenuKeys: vm => {
            const keys = []
            vm.menu.forEach(item => keys.push(item.path))
            return keys
        }
    },
    created () {
        // this.updateMenu()
    },
    watch: {
        collapsed (val) {

        }
    },
    methods: {
        renderIcon (h, icon) {
            return h('i', { attrs: { class: icon } })
        },
        renderMenuItem (h, menu, isFrist) {
            let iTitle
            if (isFrist) {
                iTitle = h('span', [menu.meta.title])
            } else {
                iTitle = h('span', { attrs: { style: 'padding-left: 9px' } }, [menu.meta.title])
            }
            return h('el-menu-item', { props: {
                index: menu.path,
                route: menu
            } }, [this.renderIcon(h, menu.meta.icon), iTitle])
        },
        // el-icon-caret-right
        renderSubMenu (h, menu) {
            var mmm = []
            if (menu.meta && menu.meta.icon) {
                mmm.push(this.renderIcon(h, menu.meta.icon))
            }
            mmm.push(h('span', [menu.meta.title]))
            const this2_ = this
            const subItem = [h('template', { slot: 'title' }, mmm)]
            const itemArr = []
            if (!menu.alwaysShow) {
                menu.children.forEach((item, i) => {
                    itemArr.push(this2_.renderItem(h, item, false))
                })
            }
            return h('el-submenu', { props: { index: menu.path } }, subItem.concat(itemArr))
        },
        renderItem (h, menu, chsss) {
            if (menu.children && !menu.noChildMenu) {
                return this.renderSubMenu(h, menu)
            } else {
                return this.renderMenuItem(h, menu, chsss)
            }
        },
        renderMenu (h, menuTree) {
            const that = this
            const menuArr = []
            menuTree.forEach((menu, i) => {
                if (menu.inLeftMenu === false) {
                    // console.log(JSON.stringify(menu, null, 2))
                } else {
                    menuArr.push(that.renderItem(h, menu, true))
                }
            })
            return menuArr
        }
    },
    render (h) {
        return h(
            'el-menu', {
                props: {
                    router: true,
                    collapse: this.collapse,
                    'collapse-transition': false,
                    'text-color': '#b9bde8',
                    // 'active-text-color': '#e6ff91',
                    'background-color': '#23253a'
                }
            },
            this.renderMenu(h, this.menu)
        )
    }
}
